import { Bullet, BulletList } from 'components/BulletList';
import { YellowCircle } from 'components/BulletList/BulletCharacters';
import Box from 'components/Containers/Box';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import ColumnBox from 'components/Containers/ColumnBox';
import { Row } from 'components/Containers/Row/Row';
import RowBox from 'components/Containers/RowBox';
import SpreadBox from 'components/Containers/SpreadBox';
import OText from 'components/CText/OText';
import DisclaimerPortal from 'components/Disclaimer/DisclaimerPortal';
import { Button } from 'components/form/Button';
import { Image } from 'components/Image/Image';
import { Lottie } from 'components/Lottie/Lottie';
import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';

const AutoDDSuccessView = props => {
  return (
    <SectionContainer
      datatestid="auto-dd-success-module"
      padding="padT40 padB48 m-padT0 m-padT0 "
    >
      {props.seenPixel}
      <Row>
        <SpreadBox alignItemsStretch>
          <ColumnBox widthClassName="format52 m-format100">
            <CenterAlignBox className="d-hide ">
              {props.showConfetti && (
                <Box className="pos-abs format100">
                  <Lottie
                    autoplay={true}
                    loop={true}
                    style={{ height: '100vw', width: '100vw' }}
                    src={'/images/lottie/pre-qual-confetti.json'}
                  />
                </Box>
              )}
              <Image imgClass={props.hero} />
            </CenterAlignBox>
            <Label type="H3 mH5" className="padB16">
              {props.title}
            </Label>
            <Label type="Body-1" className="padB24">
              {props.content}
            </Label>
            <BulletList className="m-margB0">
              {props.bullets?.map((b, x) => (
                <Bullet
                  key={x}
                  textClass="padL16 padB16 Body-1"
                  bulletCharacter={<YellowCircle />}
                >
                  {b.text}
                </Bullet>
              ))}
            </BulletList>
            <Box className="padB32">
              <Button
                className="bgImageW210"
                mrphType="primary"
                onClick={props.onClickExploreSesameCash}
              >
                {props.exploreCTAText}
              </Button>
            </Box>
            <Label type="Body-1" className="padB24">
              {props.oneTimeTransferContent}
            </Label>
            <Box>
              <Button
                className="bgImageW210"
                mrphType="standard"
                onClick={props.onClickOneTimeTransfer}
              >
                {props.oneTimeTransferCTA}
              </Button>
            </Box>
          </ColumnBox>
          <RowBox
            widthClassName="format48 pos-rel"
            className="t-hide"
            alignItemsEnd
          >
            {props.showConfetti && (
              <Box className="pos-abs format100">
                <Lottie
                  autoplay={true}
                  loop={true}
                  style={{ height: '500px', width: '500px' }}
                  src={'/images/lottie/pre-qual-confetti.json'}
                />
              </Box>
            )}
            <CenterAlignBox className="height100">
              <Image imgClass={props.hero} />
            </CenterAlignBox>
          </RowBox>
        </SpreadBox>
      </Row>
      <DisclaimerPortal name="auto_dd_pending">
        <OText text={props.disclaimers} />
      </DisclaimerPortal>
    </SectionContainer>
  );
};

export default AutoDDSuccessView;
